import { render, staticRenderFns } from "./PruningDetails.vue?vue&type=template&id=678e3ef6&scoped=true&lang=html&"
import script from "./PruningDetails.vue?vue&type=script&lang=js&"
export * from "./PruningDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678e3ef6",
  null
  
)

export default component.exports